import { Transaction } from "../models/Transaction";
import { Cols } from "../shared/Consts";
import { usePath } from "../libs/path/PathProvider";
import usePortfolio from "../hooks/PortfolioProvider";
import PortUtils from "../portlibs/PortUtils";
import TransactionTable from "../components/TransactionTable";
import { useHistoryFilter } from "../components/HistoryFilter";

export default function HistoryPage(){
    const {query} = usePath()
    const {account,currency,filter} = PortUtils.getFilter(query)
    const {portfolio} = usePortfolio()
    const cols = [Cols.date, Cols.name, Cols.accountId, Cols.type, Cols.quantity, Cols.price, Cols.total, Cols.gain, Cols.note]
    const historyFilter = useHistoryFilter()
    const holdings = portfolio.filter(currency,filter,account,false)
    const rows : Transaction[] = []
    for(let holding of holdings){
        const {transactions} = PortUtils.excludeFilter(holding.transactions, historyFilter)
        rows.push(...transactions)
    }
    return <TransactionTable tableName="history" cols={cols} rows={rows} infiniteScroll={true}/>

}